import React from 'react';
import { Package, RefreshCw, Clock, CheckCircle } from 'lucide-react';

const Returns = () => {
  return (
    <div className="min-h-screen pt-44 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            İade ve Değişim
          </h1>
          <p className="text-lg text-gray-600">
            Memnuniyetiniz bizim için önemlidir
          </p>
        </div>

        {/* Icons Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <Package className="w-12 h-12 text-junto-red mx-auto mb-2" />
            <p className="text-sm font-medium text-gray-700">Kolay İade</p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <RefreshCw className="w-12 h-12 text-junto-red mx-auto mb-2" />
            <p className="text-sm font-medium text-gray-700">Hızlı Değişim</p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <Clock className="w-12 h-12 text-junto-red mx-auto mb-2" />
            <p className="text-sm font-medium text-gray-700">14 Gün</p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-6 text-center">
            <CheckCircle className="w-12 h-12 text-junto-red mx-auto mb-2" />
            <p className="text-sm font-medium text-gray-700">Garantili</p>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-6">
          {/* Şirket Bilgileri */}
          <section className="bg-gradient-to-r from-junto-red to-red-700 text-white rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4">Şirket Bilgilerimiz</h2>
            <div className="space-y-2">
              <p><strong>Ticari Ünvan:</strong> Küme Kahve Sanayi İthalat İhracat Ticaret Limited Şirketi</p>
              <p><strong>E-posta:</strong> mehmet@juntokahve.com</p>
              <p><strong>KEP Adresi:</strong> juntokahve@hs03.kep.tr</p>
              <p><strong>MERSİS No:</strong> 0167118788300001</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">İade Koşulları</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Ürünlerinizi teslim aldığınız tarihten itibaren 14 gün içinde iade edebilirsiniz. 
              İade edilecek ürünlerin aşağıdaki koşulları sağlaması gerekmektedir:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Ürün ambalajı açılmamış ve hasarsız olmalıdır</li>
              <li>Gıda ürünleri hijyen kuralları gereği iade kabul edilemez (açılmış paketler)</li>
              <li>İade faturası ve ürün etiketi eksiksiz olmalıdır</li>
              <li>Ürün kullanılmamış ve orijinal ambalajında olmalıdır</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Değişim Koşulları</h2>
            <p className="text-gray-700 leading-relaxed">
              Ürününüzde herhangi bir hasar veya kusur tespit ederseniz, ürünü teslim aldığınız 
              tarihten itibaren 14 gün içinde bizimle iletişime geçerek değişim talebinde bulunabilirsiniz. 
              Hasarlı veya kusurlu ürünlerin değişimi ücretsizdir.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">İade Süreci</h2>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="bg-junto-red text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">1</div>
                <div>
                  <p className="font-semibold text-gray-900">İletişime Geçin</p>
                  <p className="text-gray-600 text-sm">info@juntokahve.com adresinden iade talebinizi iletin</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-junto-red text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">2</div>
                <div>
                  <p className="font-semibold text-gray-900">Onay Alın</p>
                  <p className="text-gray-600 text-sm">İade talebiniz değerlendirildikten sonra size geri dönüş yapılır</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-junto-red text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">3</div>
                <div>
                  <p className="font-semibold text-gray-900">Ürünü Gönderin</p>
                  <p className="text-gray-600 text-sm">Ürünü orijinal ambalajıyla birlikte kargo ile gönderin</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="bg-junto-red text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0">4</div>
                <div>
                  <p className="font-semibold text-gray-900">Para İadesi</p>
                  <p className="text-gray-600 text-sm">Ürün tarafımıza ulaştıktan sonra 10 iş günü içinde ödemeniz iade edilir</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Kargo Ücretleri</h2>
            <p className="text-gray-700 leading-relaxed">
              İade edilecek üründe herhangi bir kusur yoksa, kargo ücreti müşteriye aittir. 
              Ürün kusurlu veya hasarlı ise, kargo ücreti firmamız tarafından karşılanır.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">İletişim</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              İade ve değişim talepleriniz için bizimle iletişime geçebilirsiniz:
            </p>
            <div className="p-6 bg-gray-50 rounded-xl border-l-4 border-junto-red">
              <p className="text-gray-700 mb-2"><strong>E-posta:</strong> mehmet@juntokahve.com</p>
              <p className="text-gray-700"><strong>KEP Adresi:</strong> juntokahve@hs03.kep.tr</p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-6 mt-8">
            <p className="text-sm text-gray-500 text-center">
              Tüketici haklarınız Tüketici Kanunu kapsamında korunmaktadır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Returns;
